export const authorities = ['ROLE_ADMIN', 'ROLE_COMPANY_ADMIN', 'ROLE_COMPANY_USER'] as const;
export type AuthorityType = (typeof authorities)[number];

export const userTypes = ['ADMIN', 'COMPANY_ADMIN', 'COMPANY_USER'] as const;
export type UserType = (typeof userTypes)[number];

export const statuses = ['ENABLED', 'DISABLED'] as const;
export type StatusType = (typeof statuses)[number];

export const insectsVariationStates = ['LOW', 'MEDIUM', 'HIGH'] as const;
export type InsectsVariationStateType = (typeof insectsVariationStates)[number];

export const statsDates = ['RAW', 'DAY', 'MONTH'] as const;
export type StatsDateType = (typeof statsDates)[number];

export const statsSecondaryMetrics = ['AVG_TEMPERATURE', 'AVG_HUMIDITY', 'AVG_WIND'] as const;
export type StatsSecondaryMetric = (typeof statsSecondaryMetrics)[number];

export const menus = ['dashboard', 'users', 'treatments', 'settings', 'userProfile', 'plots', 'notifications', 'traps', 'aemet', 'gdas', 'trapImages', 'companies'] as const;
export type MenuType = (typeof menus)[number];

export const notificationTypes = [
    'TRAP_PLOT_PHEROMONE_REPLACEMENT',
    'TRAP_PLOT_DISEASE',
    'TRAP_PLOT_PLAGUE',
    'TRAP_IMAGE_INSECTS_VARIATION',
    'TRAP_IMAGE_INSECTS_COUNT'
] as const;
export type NotificationType = (typeof notificationTypes)[number];

export const levels = ['LOW', 'MEDIUM', 'HIGH'] as const;
export type Level = (typeof levels)[number];

export const crops = [
    'APRICOT',
    'EGGPLANT',
    'BROCCOLI',
    'PUMPKIN',
    'CABBAGE',
    'CHERRY',
    'PLUM',
    'ESCAROLE',
    'LETTUCE',
    'LEMON',
    'MANDARIN',
    'ORANGE',
    'PEACH',
    'MELON',
    'NECTARINE',
    'CUCUMBER',
    'FLAT_NECTARINE',
    'FLAT_PEACH',
    'WATERMELON',
    'TOMATO',
    'GRAPE'
] as const;
export type CropType = (typeof crops)[number];

export const doseUnits = ['LITER', 'KILOGRAM'] as const;
export type DoseUnitType = (typeof doseUnits)[number];

export const plagues = [
    'A_GAMMA',
    'CERATITIS_CAPITATA',
    'EMPOASCA_VITIS',
    'HELIOTIS',
    'LOBESIA_BOTRANA',
    'PRAYS_CITRI',
    'APHID',
    'S_EXIGUA',
    'S_LITTORALIS',
    'TRIPS',
    'TUTA_ABSOLUTA',
    'OSTRINIA_NUBILALIS'
] as const;
export type PlagueType = (typeof plagues)[number];

export const farmings = ['GREENHOUSE', 'OPENFIELD'] as const;
export type FarmingType = (typeof farmings)[number];

export const phaseTypes = ['EGG', 'L1_L3', 'L4_L6', 'N1_N2', 'N1_N4', 'PUPA', 'ADULT'] as const;
export type PhaseType = (typeof phaseTypes)[number];

export const pathogens = [
    'HYALOPERONOSPORA_PARASITICA',
    'BREMIA_LACTUCAE',
    'PSEUDOPERONOSPORA_CUBENSIS',
    'PLASMOPARA_VITICOLA',
    'BOTRYTIS_CINEREA',
    'ERYSIPHE_NECATOR',
    'PODOSPHAERA_XANTHII',
    'PODOSPHAERA_PANNOSA',
    'TAPHRINA_DEFORMANS',
    'MONILINIA'
] as const;
export type PathogenType = (typeof pathogens)[number];

export const plagueRiskTypes = ['APHID'] as const;
export type PlagueRiskType = (typeof plagueRiskTypes)[number];
